import { Container, Heading, Link, Box } from '@hover/blueprint';
import React from 'react';
import { URLS } from '../../../constants';

const Header: React.FC = () => (
  <Container
    pt={{ base: 1000, tablet: '110px', desktop: 1000 }}
    mb={{ base: '88px', tablet: '80px', desktop: 800 }}
    maxW="880px"
    px={500}
  >
    <Heading
      textAlign="center"
      size={{ base: 500, tablet: 600, desktop: 700 }}
      isLight
      marginBottom={{ base: 500, desktop: 600 }}
      as="h2"
    >
      Choose the plan that best fits your team
    </Heading>
    <Box
      mx="auto"
      flexDir="column"
      alignItems="center"
      maxW={{ base: '100%', tablet: '90%' }}
    >
      <Heading
        as="p"
        textAlign="center"
        size={{ base: 300, tablet: 500 }}
        isDisplay
      >
        Take a look at our full feature breakdown.
      </Heading>
      <Heading
        as="p"
        textAlign="center"
        size={{ base: 300, tablet: 500 }}
        isDisplay
      >
        Still wonder which is best for your team?{' '}
        <Link
          color="primary.600"
          href={URLS.pricing.contactSales}
          fontWeight={600}
          isExternal
        >
          We’re here to help.
        </Link>
      </Heading>
    </Box>
  </Container>
);

export default Header;
